import * as React from "react";
import { AutoCompleteInput, Checkbox, ColorPallet, ColorPicker, Input, Label, PortalContainer } from "uxp/components";
import { findAvailableFields, findAvailableFieldsInSchema, IUIPropertyDefinition } from "../../../common/common";
import { ColorPickerDialog, CustomColorPicker, IColorForRange, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../../common/ui-props/common";
import jp from 'jsonpath'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bindContainerId, hasValue } from "../../../../util";
import classNames from "classnames";
import IconEditor from "../../../common/icon-selector/IconEditor";



export interface IPercentageCircleProps {
    color?: string;
    thickness?: number;
    backgroundCircleColor?:string;
    percentageValue?: number;
    backgroundColor?:string;
    bulletRadius?:number;
    field?: string,
    min?:number,
    max?:number,
    refreshInterval?: number,
    channel?: string,

}


export interface INewColorButton {
    onAddNew: (colorForRange: { color: string, stopAt: number }) => void,
}

export const NewColorButton: React.FunctionComponent<INewColorButton> = (props) => {

    const [showColorPicker, setShowColorPicker] = React.useState<boolean>(false)
    const [newColorForRange, setNewColorForRange] = React.useState<{ color: string, stopAt: number }>()

    let addButtonRef = React.useRef(null)

    React.useEffect(() => {
        setNewColorForRange({ ...newColorForRange, stopAt: 3 })
    }, [showColorPicker])

    return (
        <>
            <div
                className="plus"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    cursor: 'pointer'
                }}
                ref={addButtonRef}
                onClick={() => {
                    setShowColorPicker(true)
                }}
            >
                <FontAwesomeIcon icon={['fas', 'plus']} />
            </div>

            <ColorPickerDialog
                onClose={() => {
                    setShowColorPicker(false)
                    if (newColorForRange) {
                        props.onAddNew(newColorForRange)
                    }
                }}
                show={showColorPicker}
                onChange={(v) => setNewColorForRange({
                    color: v.color,
                    stopAt: v.from,
                })}
                triggerButtonRef={addButtonRef}
                colorForRange={{
                    color: newColorForRange?.color,
                    from: newColorForRange?.stopAt,
                }}
            />
        </>
    )
}

export function CircularPercentageProperty(title: string, props: IPercentageCircleProps): IUIPropertyDefinition<IPercentageCircleProps> {
    return {
        defaults: props,
        render: (props, uxpContext, data, containerId) => {
            let [selectedColorForRangeIndex, setSelectedColorForRangeIndex] = React.useState<number>()

            const [showColorPicker, setShowColorPicker] = React.useState<boolean>(false)

            let _props = props.uiProps
            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();
            return <PropertyContainer>

                <PropertyContainerTitle>{title}</PropertyContainerTitle>
                <PropertyGroup>
                <Property id={bindContainerId('field', containerId)}>
                        <PropertyTitle>Field</PropertyTitle>
                        <AutoCompleteInput
                            options={pv}
                            value={_props.field || ''}
                            onChange={s => {

                                jp.apply(_props, '$.field', () => (s))
                                props.onChange(_props)
                            }}
                            className="widget-designer-input"
                        />

                    </Property>
                    <Property id={bindContainerId('min', containerId)}>
                        <PropertyTitle>Min</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.min?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.min', () => (num))
                                props.onChange(_props)
                            }}
                        />

                    </Property>
                    <Property id={bindContainerId('max', containerId)}>
                        <PropertyTitle>Max</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.max?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.max', () => (num))
                                props.onChange(_props)
                            }}
                        />

                    </Property>

                    <Property>
                        <PropertyTitle>Thickness</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.thickness?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.thickness', () => (num))
                                props.onChange(_props)
                            }}
                        />

                    </Property>
                    <Property>
                        <PropertyTitle>Bullet Radius</PropertyTitle>
                        <Input
                            type="number"
                            value={_props?.bulletRadius?.toString() || '0'}
                            onChange={s => {
                                let num = Number(s) || 0
                                jp.apply(_props, '$.bulletRadius', () => (num))
                                props.onChange(_props)
                            }}
                        />

                    </Property>


                    <Property>
                        <PropertyTitle>Arc Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props?.color || ''}
                            onChange={s => {
                                jp.apply(_props, '$.color', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>
                    <Property>
                        <PropertyTitle>Background Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props?.backgroundColor || ''}
                            onChange={s => {
                                jp.apply(_props, '$.backgroundColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>
                    <Property>
                        <PropertyTitle>Background Circle Color</PropertyTitle>
                        <CustomColorPicker contextData={props.contextData}
                            color={_props?.backgroundCircleColor || ''}
                            onChange={s => {
                                jp.apply(_props, '$.backgroundCircleColor', () => (s))
                                props.onChange(_props)
                            }}
                        />
                    </Property>
                </PropertyGroup>
            </PropertyContainer>
        }
    };
}
